
<template>
  <span v-if="validPaymentMethods.length === 0">Nenhum método de pagamento disponível</span>
  <v-autocomplete v-else
                  v-model="value"
                  v-model:search="searchText"
                  :items="validPaymentMethods"
                  :loading="loading"
                  item-title="name"
                  item-value="id"
                  hide-details
                  :label="label"
                  clearable
                  :return-object="returnObject"
                  density="compact">
    <template v-slot:no-data>
      <div class="px-4">Digite sua busca</div>
    </template>
  </v-autocomplete>
</template>
<script>
import api from '@/services'

export default {
  components: {},
  props: {
    user: Object,
    label: String,
    modelValue: Object,
    returnObject: Boolean,
    onlineOnly: Boolean,
    allowOnline: { type: Boolean, default: true },
    restrictedTypes: Array,
    showDisabled: Boolean,
    selectedId: Number,
    /** When set, hide methods whose minimum_due_amount exceeds this total */
    dueAmount: { type: Number, default: null },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      requestingApi: false,
      lstObjects: [],
      searchText: null,
      previousSearch: "",
      loading: false,
      timeoutSearchDelay: null,
      enableSearch: false,
    };
  },
  created() {
    var vm = this;

    vm.submitSearch();
  },
  mounted() { },
  activated() { },
  methods: {
    waitAndSearch() {
      var vm = this;
      if (vm.timeoutSearchDelay) {
        clearTimeout(vm.timeoutSearchDelay);
      }
      if (vm.searchText != "" && vm.searchText != " ") {
        vm.timeoutSearchDelay = setTimeout(() => {
          vm.submitSearch();
        }, 1000);
        vm.loading = true;
      }
    },
    submitSearch() {
      var vm = this;
      if (!vm.requestingApi) {
        let _searchText = vm.searchText;
        if (vm.enableSearch) {
          let _prev = (vm.previousSearch || "").toUpperCase();
          let _act = (_searchText || "").toUpperCase();
          if (_act == "" || (_act == " " && _prev == _act)) {
            vm.loading = false;
            return;
          }
        }
        vm.requestingApi = true;
        vm.loading = true;
        return new Promise((resolve, reject) => {
          api.paymentMethod
            .list({ searchText: _searchText, itemsPerPage: 30 }, 1)
            .then((result) => {
              vm.lstObjects = result?.data?.filter(pm => vm.showDisabled || pm.enabled) || result || [];
              if (result?.total && result?.total > 30) {
                vm.enableSearch = true;
              }
            })
            .catch((err) => {
              //
            })
            .finally(() => {
              vm.requestingApi = false;
              vm.loading = false;
              if (vm.selectedId) {
                vm.changeSelectedPayment(vm.selectedId);
              }
            });
        });
      }
    },
    changeSelectedPayment(newVal) {
      const vm = this;

      if (newVal && !isNaN(newVal) && vm.validPaymentMethods?.length > 0) {
        vm.value = vm.validPaymentMethods.find(pm => pm.id == newVal);
      }
    }
  },
  computed: {
    validPaymentMethods() {
      const vm = this;
      let filtered = vm.lstObjects.map(x => Object.assign(x));

      if (vm.onlineOnly) {
        filtered = filtered.filter(pm => pm.allow_online_payment);
      }

      if (!vm.allowOnline) {
        filtered = filtered.filter(pm => !pm.allow_online_payment);
      }

      if (vm.restrictedTypes?.length > 0) {
        filtered = filtered.filter(pm => vm.restrictedTypes.includes(pm.type));
      }

      if (vm.dueAmount != null && !isNaN(vm.dueAmount)) {
        const amount = Number(vm.dueAmount);
        filtered = filtered.filter(
          pm => (Number(pm.minimum_due_amount) || 0) <= amount
        );
      }

      return filtered;
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    searchText(newVal, oldVal) {
      if (
        newVal &&
        newVal != " " &&
        newVal.toUpperCase() != oldVal?.toUpperCase()
      ) {
        if (this.enableSearch) {
          this.waitAndSearch();
        }
      }
    },
    validPaymentMethods(methods) {
      const selected = this.modelValue;
      if (!selected) return;
      const id = selected?.id ?? selected;
      if (id == null) return;
      const stillValid = methods.some(pm => pm.id == id);
      if (!stillValid) {
        this.$emit("update:modelValue", null);
      }
    },
    selectedId: {
      handler(newVal) {
        this.changeSelectedPayment(newVal);
      },
      immediate: true,
    },
  },
};
</script>
